var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5603 5.43273C10.8046 5.67663 10.8049 6.07236 10.561 6.31662L6.32349 10.5604C6.0796 10.8046 5.68387 10.8049 5.43961 10.561C5.19535 10.3171 5.19506 9.92139 5.43896 9.67713L9.67646 5.43338C9.92036 5.18913 10.3161 5.18883 10.5603 5.43273Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26068 6.49556C5.50476 6.73964 5.50476 7.13536 5.26068 7.37944L3.49193 9.14819C3.04639 9.59374 2.79608 10.198 2.79608 10.8281C2.79608 11.4582 3.04639 12.0625 3.49193 12.5081C3.93748 12.9536 4.54177 13.2039 5.17187 13.2039C5.48386 13.2039 5.7928 13.1425 6.08104 13.0231C6.36928 12.9037 6.63119 12.7287 6.8518 12.5081L8.62055 10.7393C8.86463 10.4952 9.26035 10.4952 9.50443 10.7393C9.74851 10.9834 9.74851 11.3791 9.50443 11.6232L7.73568 13.3919C7.399 13.7286 6.99929 13.9957 6.55939 14.1779C6.11949 14.3601 5.64801 14.4539 5.17187 14.4539C4.21025 14.4539 3.28802 14.0719 2.60805 13.3919C1.92808 12.712 1.54608 11.7897 1.54608 10.8281C1.54608 9.86651 1.92808 8.94427 2.60805 8.26431L4.3768 6.49556C4.62088 6.25148 5.0166 6.25148 5.26068 6.49556Z",
    fill: "#6C7689"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26431 2.60811C8.94427 1.92814 9.86651 1.54614 10.8281 1.54614C11.7897 1.54614 12.712 1.92814 13.3919 2.60811C14.0719 3.28808 14.4539 4.21031 14.4539 5.17193C14.4539 6.13355 14.0719 7.05578 13.3919 7.73574L11.6232 9.50449C11.3791 9.74857 10.9834 9.74857 10.7393 9.50449C10.4952 9.26042 10.4952 8.86469 10.7393 8.62061L12.5081 6.85186C12.9536 6.40631 13.2039 5.80202 13.2039 5.17193C13.2039 4.54183 12.9536 3.93754 12.5081 3.49199C12.0625 3.04645 11.4582 2.79614 10.8281 2.79614C10.198 2.79614 9.59374 3.04645 9.14819 3.49199L7.37944 5.26074C7.13536 5.50482 6.73964 5.50482 6.49556 5.26074C6.25148 5.01667 6.25148 4.62094 6.49556 4.37686L8.26431 2.60811Z",
    fill: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.33a39c3f792f529c96f00096b785a9cc.svg";
export { ForwardRef as ReactComponent };